module.exports = __webpack_public_path__ + "files/d063f1a8029929f5410daea780a5b3c5.svg";